import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCompare } from '../../context/CompareContext';
import './CompareFloatBar.css';

const CompareFloatBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { compareItems, removeFromCompare, clearCompare, compareCount } = useCompare();

  // Don't show on compare page itself
  if (compareCount === 0 || location.pathname === '/compare') return null;

  return (
    <div className="compare-float-bar">
      <div className="compare-float-items">
        {compareItems.map(item => (
          <div key={item.id} className="compare-float-item">
            {item.image && <img src={item.image} alt="" className="compare-float-img" />}
            <span className="compare-float-name">{item.name}</span>
            <button className="compare-float-remove" onClick={() => removeFromCompare(item.id)} title="Remove">✕</button>
          </div>
        ))}
      </div>
      <span className="compare-float-count">{compareCount}/2</span>
      <button
        className="compare-float-btn"
        disabled={compareCount < 2}
        onClick={() => navigate('/compare')}
      >
        Compare Now
      </button>
      <button className="compare-float-clear" onClick={clearCompare}>Clear</button>
    </div>
  );
};

export default CompareFloatBar;
